import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TableWrapper: {
    position: 'relative'
  },
  ApplyFilterWrapper: {
    marginTop: theme.spacing(4),
    textAlign: 'right'
  },
  ActivateButton: {
    padding: theme.spacing(0)
  },
  dateChip: {
    display: 'flex',
    '& time': {
      marginLeft: theme.spacing(1)
    }
  },
  FilterChip: {
    display: 'flex',
    '& span': {
      marginLeft: theme.spacing(1)
    }
  },
  categoryDesc: {
    display: 'table-row'
  },
  priceChipWrapper: {
    marginBottom: theme.spacing(0.5),
    '& .MuiChip-root': {
      justifyContent: 'flex-start',
      direction: 'ltr',
      [theme.breakpoints.up('sm')]: {
        width: '100%'
      }
    }
  },
  priceChip: {
    '& strong': {
      marginRight: theme.spacing(0.5),
      display: 'inline-block'
    }
  },
  priceColumnTh: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    '& span:last-child': {
      lineHeight: '1',
      fontSize: '0.75rem',
      color: '#888'
    }
  }
}))
